import {
  AddIcon,
} from "@chakra-ui/icons";
import {
  Button,
  Divider,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Box,
} from "@chakra-ui/react";
import { ConfiguracaoFormFields } from "./configuracao-form-fields";
import { ConfiguracoesTable } from "./configuracoes-table";
import { RegraConciliacaoCard } from "./regra-conciliacao-card";
import { ConciliationConfigModalProps } from "./types";

export default function ConciliationConfigModal({
  isOpen,
  isLoadingConfiguracoes,
  isSubmittingConfiguracao,
  isLoadingConfiguracaoById,
  editingConfiguracaoId,
  configuracoes,
  configuracaoForm,
  onClose,
  onNewConfiguracao,
  onEditConfiguracao,
  onDeleteConfiguracao,
  onSubmitConfiguracao,
  onChangeNome,
  onChangeOrdem,
  onChangeVersao,
  onChangeCondicaoSeguroEtapa,
  onAddRegra,
  onRemoveRegra,
  onUpdateRegra,
  onUpdateRegraOrigem,
  onUpdateRegraDestino,
}: ConciliationConfigModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="7xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Configuração de Conciliação</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <ConfiguracoesTable
            configuracoes={configuracoes}
            isLoadingConfiguracoes={isLoadingConfiguracoes}
            isLoadingConfiguracaoById={isLoadingConfiguracaoById}
            isSubmittingConfiguracao={isSubmittingConfiguracao}
            onNewConfiguracao={onNewConfiguracao}
            onEditConfiguracao={onEditConfiguracao}
            onDeleteConfiguracao={onDeleteConfiguracao}
          />

          <Divider my={6} />

          <ConfiguracaoFormFields
            configuracaoForm={configuracaoForm}
            editingConfiguracaoId={editingConfiguracaoId}
            onChangeNome={onChangeNome}
            onChangeOrdem={onChangeOrdem}
            onChangeVersao={onChangeVersao}
            onChangeCondicaoSeguroEtapa={onChangeCondicaoSeguroEtapa}
          />

          <Flex justifyContent="space-between" alignItems="center" mb={3}>
            <Text fontWeight="semibold">Regras de Conciliação</Text>
            <Button size="sm" leftIcon={<AddIcon />} onClick={onAddRegra}>
              Adicionar regra
            </Button>
          </Flex>

          <Box maxH="50vh" overflowY="auto" pr={1}>
            {configuracaoForm.configuracao.regras.map((regra, index) => (
              <RegraConciliacaoCard
                key={`regra-${index}`}
                regra={regra}
                index={index}
                totalRegras={configuracaoForm.configuracao.regras.length}
                onRemoveRegra={onRemoveRegra}
                onUpdateRegra={onUpdateRegra}
                onUpdateRegraOrigem={onUpdateRegraOrigem}
                onUpdateRegraDestino={onUpdateRegraDestino}
              />
            ))}
          </Box>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Fechar
          </Button>
          <Button
            colorScheme="primary"
            onClick={() => void onSubmitConfiguracao()}
            isLoading={isSubmittingConfiguracao || isLoadingConfiguracaoById}
          >
            {editingConfiguracaoId ? "Salvar edição" : "Criar configuração"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}